import Button from '@/components/ui/Button'
import { Icon } from '@/icons/Icon'

type SheetProps = React.HTMLAttributes<HTMLElement> & {
  trigger: React.ReactNode
  isVisible: boolean
  isMenu?: boolean
  close: () => void
  fullHeight?: boolean
}

export default function FullScreenCover({ trigger, isVisible, close, children }: SheetProps) {
  return (
    <>
      {trigger}
      {isVisible && (
        <div className="fixed left-0 top-0 z-[9999] flex h-dvh w-full flex-col bg-white dark:bg-black">
          <div className="absolute z-50 flex h-20 w-full items-center justify-end bg-white/90 px-3 backdrop-blur-md dark:bg-black/90">
            <Button onClick={close} size="large" className="z-20">
              <Icon name="xmark" />
            </Button>
          </div>

          <div className="h-dvh w-full overflow-y-scroll pt-20">{children}</div>
        </div>
      )}
    </>
  )
}
